class UserService {

    constructor(SERVICE_LOCATIONS, $http, $q, $rootScope, $location) {

        var _self = this;

        _self.lastStatus = 0;

        $rootScope.$watch("currentUser.selectedClientId", (newval) => {
            if(!!newval) {
                localStorage.setItem('cpm.user.selectedClient', $rootScope.currentUser.selectedClientId);
            }
        });

        return { 

            login: (details) => {
                let deferred = $q.defer();
                $http.post(SERVICE_LOCATIONS.CPM_API + 'auth/login', details, {silent: true})
                    .then((response) => {

                        _self.lastStatus = response.status;
                        if(response.data.status == "ERROR") {
                            deferred.reject({error: response.status, message: response.data.message});
                        }
                        else {
                            this.setCurrentUser(response.data, $rootScope);
                            deferred.resolve(response);
                        }

                    }, (response) => {
                        $rootScope.currentUser = null;
                        _self.lastStatus = response.status;                        
                        if (response.status === 401) {
                            deferred.reject({error: response.status, message: "Access is denied"});
                        }
                        else {
                            deferred.reject({error: response.status, message: "There was a server error while trying to log you in"});
                        }
                });
                return deferred.promise;
            },

            logout: () => {
                let deferred = $q.defer();
                $http.put(SERVICE_LOCATIONS.CPM_API + 'auth/logout', null, {silent: true})
                    .then((response) => {
                        deferred.resolve(response);
                        $rootScope.currentUser = null;
                    }, (response) => {
                        deferred.reject(response);
                });
                return deferred.promise;
            },

            getCurrentUser: () => {
                let deferred = $q.defer();
                if (this.currentUser == null) {

                    if(_self.lastStatus >= 500) {
                        deferred.reject();
                    }
                    else {
                        $http.get(SERVICE_LOCATIONS.CPM_API + "auth/user", {silent: true})
                            .then((response) => {

                                _self.lastStatus = response.status;
                                this.setCurrentUser(response.data, $rootScope);
                                deferred.resolve($rootScope.currentUser);

                            }, (response) => {
                                _self.lastStatus = response.status;
                                $rootScope.currentUser = null;
                                deferred.reject(response);
                                if(response.status >= 500) {
                                    console.log("server error");
                                    $location.path('/login?error=500&errorMessage=There+was+a+server+error+while+trying+to+log+you+in');
                                }                            
                            });
                    }
                } else {
                    deferred.resolve($rootScope.currentUser);
                }
                return deferred.promise;
            },

            updateSettings: settings => {
                let deferred = $q.defer();
                $http.put(SERVICE_LOCATIONS.CPM_API + 'auth/settings', settings, {errorMessage: 'Failed to save settings.'})
                    .then((response) => {
                        deferred.resolve(response);
                    }, (response) => {
                        deferred.reject(response);
                });
                return deferred.promise;
            },
            
            changeOwnPassword: (password) => {
                let deferred = $q.defer();
                $http.put(SERVICE_LOCATIONS.CPM_API + 'auth/password', password, {errorMessage: 'Failed to change password.'})
                    .then((response) => {
                        deferred.resolve(response);
                    }, (response) => {
                        deferred.reject(response);
                });
                return deferred.promise;
            },
            
            changePassword: (contentType, id, password) => {
                let deferred = $q.defer();
                $http.put(SERVICE_LOCATIONS.CPM_API + contentType + '/' + id + '/password', password, {errorMessage: 'Failed to change password.'})
                    .then((response) => {
                        deferred.resolve(response);
                    }, (response) => {
                        deferred.reject(response);
                });
                return deferred.promise;
            },
            
            setPermissions: (contentType, id, permissions) => {
                let deferred = $q.defer();
                $http.put(SERVICE_LOCATIONS.CPM_API + contentType + '/' + id + '/permissions', permissions, {errorMessage: 'Failed to set permissions.'})
                    .then((response) => {
                        deferred.resolve(response);
                    }, (response) => {
                        deferred.reject(response);
                });
                return deferred.promise;
            },

            flushEntityCache: () => {
                let deferred = $q.defer();
                $http.put(SERVICE_LOCATIONS.CPM_API + 'auth/flush-cache', null, {errorMessage: 'Failed to flush entity cache.'})
                    .then((response) => {
                        deferred.resolve(response);
                    }, (response) => {
                        deferred.reject(response);
                });
                return deferred.promise;
            },

            getLatestBuildVersion: (currentBranch) => {
                let deferred = $q.defer();
                $http.get(SERVICE_LOCATIONS.CPM_API + 'auth/version/' + currentBranch, {silent: true})
                    .then((response) => {
                        deferred.resolve(response);
                    }, (response) => {
                        deferred.reject(response);
                });
                return deferred.promise;
            },

            getCurrentBuildVersion: () => {
                let deferred = $q.defer();
                $http.get('/js/version.js')
                    .then((response) => {
                        deferred.resolve(response);
                    }, (response) => {
                        deferred.reject(response);
                });
                return deferred.promise;
            }
        };
    }

    setCurrentUser(user, $rootScope) {
        
        let selectedClientId = localStorage.getItem('cpm.user.selectedClient');
        if(!!selectedClientId) {
            user.selectedClientId = selectedClientId;
        }
        else {
            user.selectedClientId = user.clientId.toString();
            localStorage.setItem('cpm.user.selectedClient', user.selectedClientId);
        }

        $rootScope.currentUser = user;

    }

}

angular.module('cpm')
    .service('UserService', ['SERVICE_LOCATIONS', '$http', '$q', '$rootScope', '$location', UserService]);
